export const roles = {
  HL_SUPERADMIN: "hl_superadmin",
  HL_ADMIN: "hl_admin",
  HL_USER: "hl_user",
  HF_ADMIN: "hf_admin",
  HF_USER: "hf_user",
  HF_SUPER_ADMIN: "hf_superadmin",
};
